import PageHeader from "@/components/PageHeader";
import ExterneDokSection from "@/components/ExterneDokSection";
import { Tabs, TabsList, TabsTrigger, TabsContent } from "@/components/ui/tabs";
import { EXTERNE_KATEGORIEN } from "@/lib/constants";
import { FolderOpen } from "lucide-react";

export default function ExterneDokumente() {
  return (
    <div>
      <PageHeader
        eyebrow="SADCR · Dokumente"
        title="Externe Dokumente"
        description="Verlinkte Dokumente & Ressourcen nach Bereich."
        icon={FolderOpen}
      />
      <div className="p-8">
        <Tabs defaultValue={EXTERNE_KATEGORIEN[0].value}>
          <TabsList className="bg-[#0C0E12] border border-zinc-800 rounded-sm p-1 h-auto gap-1">
            {EXTERNE_KATEGORIEN.map((k) => (
              <TabsTrigger
                key={k.value}
                value={k.value}
                data-testid={`ext-tab-${k.value}`}
                className="rounded-sm data-[state=active]:bg-primary data-[state=active]:text-white text-zinc-400 text-xs uppercase tracking-wide font-medium px-4 py-2"
              >
                {k.label}
              </TabsTrigger>
            ))}
          </TabsList>

          {EXTERNE_KATEGORIEN.map((k) => (
            <TabsContent key={k.value} value={k.value} className="mt-6">
              <ExterneDokSection kategorie={k.value} katLabel={k.label} testidPrefix={`ext-${k.value}`} />
            </TabsContent>
          ))}
        </Tabs>
      </div>
    </div>
  );
}
